import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/UserAuth';

function SignUp() {
  const navigate = useNavigate();
  const { signupUserAuth } = useAuth();
  const [signupUser, setSignupUser] = useState({ email: '', password: '' });

  const _onChange = (e) => {
    setSignupUser((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
  };

  /**
   * ! Signup
   */
  const handleSignup = (e) => {
    e.preventDefault();
    if (!signupUser.email && !signupUser.password) return;

    signupUserAuth(signupUser.email, signupUser.password);

    navigate('/');
  };

  ////////////////////////////////////////////////////////////////////////////
  return (
    <div
      className='modal modal-signin position-static d-block bg-secondary py-5'
      tabIndex='-1'
      role='dialog'
      id='modalSignin'
    >
      <div className='modal-dialog' role='document'>
        <div className='modal-content rounded-5 shadow'>
          <div className='modal-header p-5 pb-4 border-bottom-0'>
            <h2 className='fw-bold mb-0'>Sign up for free</h2>
          </div>

          <div className='modal-body p-5 pt-0'>
            <form className=''>
              <div className='form-floating mb-3'>
                <input
                  required
                  type='email'
                  className='form-control rounded-4'
                  id='floatingInput'
                  placeholder='name@example.com'
                  onChange={_onChange}
                  name='email'
                  value={signupUser.email}
                />
                <label htmlFor='floatingInput'>Email address</label>
              </div>
              <div className='form-floating mb-3'>
                <input
                  required
                  type='password'
                  className='form-control rounded-4'
                  id='floatingPassword'
                  placeholder='Password'
                  autoComplete=''
                  onChange={_onChange}
                  name='password'
                  value={signupUser.password}
                />
                <label htmlFor='floatingPassword'>Password</label>
              </div>
              <button className='w-100 mb-2 btn btn-lg rounded-4 btn-primary' type='submit' onClick={handleSignup}>
                Sign up
              </button>
              <p>
                if you have an account please <Link to='/login'>Login</Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
